import s from './style.module.scss';
import { useCallback, useEffect } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const ANSWER_KEYS = {
  DUET_QUESTIONNAIRE_Q3_A1: 'feedback_view_variety',
  DUET_QUESTIONNAIRE_Q3_A2: 'feedback_view_userbase',
  DUET_QUESTIONNAIRE_Q3_A3: 'feedback_view_safety',
  DUET_QUESTIONNAIRE_Q3_A4: 'feedback_view_cpr',
  DUET_QUESTIONNAIRE_Q3_A5: 'feedback_view_userquality',
  DUET_QUESTIONNAIRE_Q3_A6: 'feedback_view_easy',
};
export default function Questionnaire(props) {
  const { setShowConfirm, answerDic, q3Answer, setQ3Answer } = props;
  const { t } = useTranslation();

  const handleInputChange = useCallback(
    (e) => {
      if (!e.target.value) {
        delete q3Answer.DUET_QUESTIONNAIRE_Q3_A7;
      } else {
        q3Answer.DUET_QUESTIONNAIRE_Q3_A7 = e.target.value;
      }
      setQ3Answer({ ...q3Answer });
    },
    [q3Answer]
  );

  const handleAnswer = useCallback(
    (key) => {
      if (q3Answer[key]) {
        delete q3Answer[key];
        setQ3Answer({ ...q3Answer });
      } else {
        q3Answer[key] = ANSWER_KEYS[key];
        setQ3Answer({ ...q3Answer });
      }
    },
    [answerDic, q3Answer]
  );

  useEffect(() => {
    if (Object.keys(q3Answer)?.length > 0) {
      setShowConfirm(true);
    } else {
      setShowConfirm(false);
    }
  }, [q3Answer]);

  return (
    <div className={s.root}>
      <div className={s.title}>{t('DUET_QUESTIONNAIRE_Q3')}</div>
      <div className={s.answerWrapper}>
        {Object.keys(ANSWER_KEYS).map((key) => (
          <div onClick={() => handleAnswer(key)} key={key} className={cx(s.answerItem)}>
            {t(key)}
            <div className={cx(s.tickIcon, { [s.active]: q3Answer[key] })} />
          </div>
        ))}
        <input
          type="text"
          value={q3Answer.DUET_QUESTIONNAIRE_Q3_A7 || ''} // 将输入框的值绑定到组件的状态
          onChange={handleInputChange}
          className={cx(s.answerItem, s.input)}
          placeholder={t('DUET_QUESTIONNAIRE_Q2_ENTER')}
        />
      </div>
    </div>
  );
}
